<a *ngIf="linkTarget.kind === 'internal'; else externalTpl" [routerLink]="linkTarget.routerLink" [queryParams]="linkTarget.queryParams" [fragment]="linkTarget.fragment" [ngClass]="classes"> <ng-content></ng-content>{{ label }} </a>

<ng-template #externalTpl>
  <a [href]="linkTarget.href" [ngClass]="classes" target="_blank" rel="noopener noreferrer"> <ng-content></ng-content>{{ label }} </a>
</ng-template>
